import React, { Component, PropTypes } from 'react';
import { Deck } from 'spectacle-ppa';

import MarkdownScript from 'helpers/markdownScript';
import markdownFile from './index.md';

import start from './sections/01_start/startSection';
import song from './sections/03_song/songSection';
import esGooberStory from './sections/11_esGooberStory/esGooberStorySection';
import missionReport from
  './sections/12_missionReport/missionReportSection';
import gameShow from './sections/20_gameShow/gameShowSection';
import classActivity from './sections/30_classActivity/classActivitySection';
import missionAssignment from
  './sections/70_missionAssignment/missionAssignmentSection';
import ending from './sections/95_ending/endingSection';
import finish from './sections/90_finish/finishSection';

const md = new MarkdownScript(markdownFile);
const level = Number(__filename.replace(/^.*level/, '').replace('.jsx', ''));
const title = md.getSectionMetadata(`Level ${level}`, 'Title');

export default class extends Component {

  static contextTypes = {
    regionData: PropTypes.object.isRequired
  };

  static metadata = {
    title
  };

  render() {
    const {regionData} = this.context;

    return (
      <Deck transition={['slide']}
            transitionDuration={800}
            progress="bar">

            {/* Start */}
            {start({ level, title, regionData })}

            {/* Theme Song */}
            {song({ level, regionData })}

            {/* Mission Report */}
            {missionReport({ level, regionData })}

            {/* Esmeralda & Goober Story */}
            {esGooberStory({ level, regionData })}

            {/* Game Show */}
            {gameShow({ level, regionData })}

            {/* Class Activity: Drawing */}
            {classActivity({ level, title, regionData })}

            {/* Ending */}
            {ending({ regionData })}

            {/* Mission Assignment */}
            {missionAssignment({ level, title, regionData })}

            {/* Finish */}
            {finish({ level, regionData })}

      </Deck>
    );
  }

}



// WEBPACK FOOTER //
// ./programs/epsHybridIntermediates/level3.jsx